// app/components/ThemeRegistry.js

"use client";

// 👈 **CRITICAL:** This marks the file as a Client Component
import { c as _c } from "react/compiler-runtime";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider, CssBaseline } from "@mui/material";
import React from 'react'; // React is required for JSX components
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";

// --- 1. Define the theme object using createTheme() ---
const theme = createTheme({
  palette: {
    primary: {
      main: "#00AD3F"
    },
    secondary: {
      main: "#226DB4"
    },
    success: {
      main: "#00B69B"
    },
    info: {
      main: "#2DB6F5"
    },
    warning: {
      main: "#FFBC2B"
    },
    danger: {
      main: "#EE368C"
    },
    dark: {
      main: "#260944"
    },
    text: {
      primary: '#222',
      secondary: '#5B5B98',
      disabled: '#818093',
      hint: '#818093'
    },
    background: {
      default: "#fff",
      paper: "#FFF"
    }
  },
  typography: {
    fontFamily: "'Sofia Pro', 'Helvetica', 'Arial', sans-serif",
    fontSize: 12
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          '&.Mui-selected': {
            backgroundColor: '#00AD3F',
            color: '#fff'
          },
          '&:hover': {
            backgroundColor: '#00AD3F',
            color: '#fff'
          }
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            color: '#FF0000'
          }
        }
      }
    }
  }
});
// -----------------------------------------------------

export default function ThemeRegistry(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CssBaseline />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={true} draggable={true} pauseOnHover={true} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <ThemeProvider theme={theme}>{t1} {t2}{children}</ThemeProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
ThemeRegistry.propTypes = {
  children: PropTypes.node.isRequired
};